// Map upstream BPS code → name normalization used in geojson
// geojson uses old names like "IRIAN JAYA" for new Papua subdivisions
export const CODE_TO_GEOJSON_NAMES = {
  "11": ["ACEH", "NANGGROE ACEH DARUSSALAM"],
  "12": ["SUMATERA UTARA"],
  "13": ["SUMATERA BARAT"],
  "14": ["RIAU"],
  "15": ["JAMBI"],
  "16": ["SUMATERA SELATAN"],
  "17": ["BENGKULU"],
  "18": ["LAMPUNG"],
  "19": ["KEPULAUAN BANGKA BELITUNG", "BANGKA BELITUNG"],
  "21": ["KEPULAUAN RIAU"],
  "31": ["DKI JAKARTA"],
  "32": ["JAWA BARAT"],
  "33": ["JAWA TENGAH"],
  "34": ["DI YOGYAKARTA", "DAERAH ISTIMEWA YOGYAKARTA"],
  "35": ["JAWA TIMUR"],
  "36": ["BANTEN"],
  "51": ["BALI"],
  "52": ["NUSA TENGGARA BARAT", "NUSATENGGARA BARAT"],
  "53": ["NUSA TENGGARA TIMUR", "NUSATENGGARA TIMUR"],
  "61": ["KALIMANTAN BARAT"],
  "62": ["KALIMANTAN TENGAH"],
  "63": ["KALIMANTAN SELATAN"],
  "64": ["KALIMANTAN TIMUR"],
  "65": ["KALIMANTAN UTARA"],
  "71": ["SULAWESI UTARA"],
  "72": ["SULAWESI TENGAH"],
  "73": ["SULAWESI SELATAN"],
  "74": ["SULAWESI TENGGARA"],
  "75": ["GORONTALO"],
  "76": ["SULAWESI BARAT"],
  "81": ["MALUKU"],
  "82": ["MALUKU UTARA"],
  // Papua subdivisions all map to IRIAN JAYA shapes in old geojson
  "91": ["IRIAN JAYA BARAT", "PAPUA BARAT"],
  "92": ["IRIAN JAYA BARAT", "PAPUA BARAT"],
  "93": ["IRIAN JAYA TENGAH", "PAPUA"],
  "94": ["IRIAN JAYA TIMUR", "PAPUA"],
  "95": ["IRIAN JAYA TIMUR", "PAPUA"],
  "96": ["IRIAN JAYA TENGAH", "PAPUA"],
};

export function statusColor(status) {
  const s = (status || "").toLowerCase();
  if (s === "kritis") return "#ef4444";
  if (s === "waspada") return "#f59e0b";
  if (s === "siaga") return "#facc15";
  if (s === "aman") return "#10b981";
  return "#64748b";
}

export function statusFill(status) {
  const s = (status || "").toLowerCase();
  if (s === "kritis") return "rgba(239, 68, 68, 0.7)";
  if (s === "waspada") return "rgba(245, 158, 11, 0.7)";
  if (s === "siaga") return "rgba(250, 204, 21, 0.7)";
  if (s === "aman") return "rgba(16, 185, 129, 0.7)";
  return "rgba(100, 116, 139, 0.55)";
}

export const PROVINCE_CENTER = {
  "11": [4.6951, 96.7494], "12": [2.1154, 99.5451], "13": [-0.7399, 100.8001],
  "14": [0.2933, 101.7068], "15": [-1.4852, 102.4381], "16": [-3.3194, 103.9145],
  "17": [-3.5778, 102.3464], "18": [-4.5586, 105.4068], "19": [-2.7411, 106.4406],
  "21": [3.9456, 108.1429], "31": [-6.2088, 106.8456], "32": [-6.9147, 107.6098],
  "33": [-7.15, 110.1403], "34": [-7.7956, 110.3695], "35": [-7.536, 112.2384],
  "36": [-6.4058, 106.064], "51": [-8.4095, 115.1889], "52": [-8.6529, 117.3616],
  "53": [-8.6574, 121.0794], "61": [-0.2787, 111.4753], "62": [-1.6815, 113.3824],
  "63": [-3.0926, 115.2838], "64": [1.6406, 116.4194], "65": [3.0731, 116.0413],
  "71": [0.6246, 123.975], "72": [-1.43, 121.4456], "73": [-3.6687, 119.974],
  "74": [-4.1449, 122.1746], "75": [0.6999, 122.4467], "76": [-2.8441, 119.2321],
  "81": [-3.2385, 130.1453], "82": [1.5709, 127.8088], "91": [-1.3361, 133.1747],
  "92": [-1.4332, 131.2558], "93": [-3.929, 136.235], "94": [-4.2699, 138.0804],
  "95": [-7.1864, 139.53], "96": [-4.0742, 138.9479],
};
